export const SET_OFFER_SEARCH = 'setOfferSearchResults';
export const SET_OFFER_BUSY = 'setOfferBusy';
export const SET_OFFER_GET = 'setOfferGet';
export const SET_OFFER_ADD_NDC = 'setOfferAddNDC';
export const SET_OFFER_REMOVE_NDC = 'setOfferRemoveNDC';
export const SET_OFFER_ADD_STATE_EXCLUSION = 'setOfferAddStateExclusion';
export const SET_OFFER_REMOVE_STATE_EXCLUSION = 'setOfferRemoveStateExclusion';
export const SET_OFFER_ADD_SEGMENT = 'setOfferAddSegment';
export const SET_OFFER_REMOVE_SEGMENT = 'setOfferRemoveSegment';
export const SET_OFFER_SAVE_SEGMENT = 'setOfferSaveSegment';
export const SET_OFFER_NAME = 'setOfferName';
export const SET_OFFER_DRUG_NAME = 'setOfferDrugName';
export const SET_OFFER_GLOBAL_PRODUCT_LIST_ID = 'setOfferGlobalProductListId';
export const SET_OFFER_PHARMA_CLIENT = 'setOfferPharmaClient';
export const SET_OFFER_EFFECTIVE_DATE = 'setOfferEffectiveDate';
export const SET_OFFER_END_DATE = 'setOfferEndDate';
export const SET_OFFER_MANUFACTURE = 'setOfferManufacture';
export const SET_OFFER_IS_PENDING_INACTIVATION = 'setOfferIsPendingInactivation';
export const SET_OFFER_MINIMUM_AGE = 'setOfferMinimumAge';
export const SET_OFFER_MAXIMUM_AGE = 'setOfferMaximumAge';
export const SET_OFFER_PROGRAM_ID = 'setOfferProgramId';
export const SET_OFFER_COMMENTS = 'setOfferComments';
export const SET_OFFER_GLOBAL_PRODUCT_LISTS_LOADING = 'setOfferGlobalProductListsLoading';
export const SET_OFFER_GLOBAL_PRODUCT_LISTS = 'setOfferGlobalProductLists';



// WEBPACK FOOTER //
// ./src/store/offer/mutations.type.js